import React from 'react'
import { Provider } from './Context'
import { Content } from './Content'

export const Page = () => {
  return (
    <Provider>
      <Content />
      {/*<OnBoarding />*/}
    </Provider>
  )
}
